import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { find, isEmpty } from 'lodash';
import { Bell } from 'lucide-react';
import MessageListContainer from './message-list.container';
import MessageItemContainer from './message-item.container';

export default function MessageContainer() {
  const {
    message,
    user,
    bmc: { collection },
  } = useSelector((selector) => selector);
  const {
    message: { fetchMessages },
    bmc: { fetchBmcs },
  } = useDispatch();

  const messages = useMemo(() => {
    if (!user?.current?.id) return [];

    const result = {};

    message.collection.forEach((messageItem) => {
      if (result[`${messageItem.bmc.id}`]) {
        result[`${messageItem.bmc.id}`].unreadMessageCount += 1;
        result[`${messageItem.bmc.id}`].unreadMentionCount +=
          messageItem.notificationable.mentions.includes(user?.current?.id);
      } else {
        result[`${messageItem.bmc.id}`] = {
          uniqKey: messageItem.bmc.id,
          title: messageItem.bmc.name,
          unreadMessageCount: 1,
          unreadMentionCount: messageItem.notificationable.mentions.includes(
            user?.current?.id,
          ),
        };
      }
    });

    return Object.values(result);
  }, [message, user]);

  useEffect(() => {
    fetchMessages();
    if (isEmpty(collection)) fetchBmcs();
  }, []);

  const handleClick = (uniqKey) => {
    const currentBmc = find(collection, ['id', uniqKey]);

    if (user.current.role === 'student' || currentBmc) {
      window.location.href = `/bmcs/${uniqKey}/portfolio?openUnreadComment=true`;
    } else {
      window.location.href = `/admin/bmc/${uniqKey}`;
    }
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <div className="message-container" tabIndex="0">
      <div>
        <div
          className={classNames({
            active: message.collection.length > 0,
          })}
        >
          <Bell className="text-primary w-6 h-auto" />
        </div>
        <MessageListContainer isHaveNotice={messages.length > 0}>
          {messages.map((messageItem) => (
            <MessageItemContainer
              key={messageItem.uniqKey}
              {...messageItem}
              onClick={handleClick}
            />
          ))}
        </MessageListContainer>
      </div>
    </div>
  );
}
